// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__o58Jd","divider":"Contact_divider__RVSE3","form-group":"Contact_form-group__d9zIc"};